import { useTranslation } from "react-i18next"
import { ProductV2 } from "types"
import { Box, SingleSelect, SingleSelectOption, Typography } from "@strapi/design-system"
import { fractionalRgbToHex } from "../ColorItem/helpers"
import { ProductCategories } from "components/Navbar/types"

const IMAGE_SIZE = 50

interface ProductPreviewProps {
  data: ProductV2
  setActiveColorIndex?: (color: number) => void
  effectType?: ProductCategories
  activeColorIndex?: number
}

export const ProductPreview = ({
  data,
  setActiveColorIndex,
  effectType,
  activeColorIndex = 0,
}: ProductPreviewProps) => {
  const { t } = useTranslation()

  return (
    <Box
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: 32,
      }}
    >
      <Box
        style={{
          display: "flex",
          flexDirection: "row",
          gap: 8,
        }}
      >
        <Box
          style={{
            // width: IMAGE_SIZE,
            // height: IMAGE_SIZE,
            width: IMAGE_SIZE,
            maxWidth: IMAGE_SIZE,
            maxHeight: IMAGE_SIZE,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img
            src={data.cover.length ? data.cover : "/none-image.svg"}
            alt={t("productPreview.imageAlt")}
            height={IMAGE_SIZE}
            style={{ borderRadius: 4, maxWidth: IMAGE_SIZE, maxHeight: IMAGE_SIZE }}
          />
        </Box>
        <Box
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "start",
            justifyContent: "center",
            gap: 2,
          }}
        >
          <Typography
            style={{
              maxWidth: "95px",
              width: "95px",
              textOverflow: "ellipsis",
              overflow: "hidden",
              whiteSpace: "nowrap",
            }}
          >
            {data.brand.length ? data.brand : t("productPreview.defaultBrand")}
          </Typography>
          <Typography
            variant="pi"
            style={{
              maxWidth: "95px",
              width: "95px",
              textOverflow: "ellipsis",
              overflow: "hidden",
              whiteSpace: "nowrap",
            }}
          >
            {data.name.length ? data.name : t("productPreview.defaultName")}
          </Typography>
        </Box>
      </Box>
      {effectType === ProductCategories.MAKEUP && setActiveColorIndex ? (
        <Box
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
            gap: 8,
          }}
        >
          <Typography>{t("productPreview.colorLabel")}</Typography>
          <Box>
            <SingleSelect value={activeColorIndex} onChange={setActiveColorIndex}>
              {data.colors.map((color, indx) => (
                <SingleSelectOption value={indx} key={indx}>
                  <Box
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      gap: 8,
                      pointerEvents: "none",
                    }}
                  >
                    <Box
                      style={{
                        background:
                          color.color[0] === "#" ? color.color : fractionalRgbToHex(color.color),
                        width: 28,
                        height: 28,
                        borderRadius: 4,
                      }}
                    />
                    <Typography>{t("productPreview.tone", { color: color.color })}</Typography>
                  </Box>
                </SingleSelectOption>
              ))}
            </SingleSelect>
          </Box>
        </Box>
      ) : null}
    </Box>
  )
}
